import clsx from "clsx";
import React from "react";
import {Hall} from "types/entities/Hall";

interface LocationTooltipProps {
    children: React.ReactNode | React.ReactNode[];
    active: boolean | null;
    onClick: (hall) => void;
    left: number;
    top: number;
}

const LocationTooltip = (props: LocationTooltipProps) => {
    const {active, onClick, left, top} = props;
    console.log(active, left, top);
    return (
        <button
            className={clsx(
                active !== null ? "opacity-100  -translate-y-full " : " pointer-events-none translate-y-0 ",
                "transform-gpu z-40 transition-all rounded-3xl duration-700 ease-in-out bg-gradient-to-br from-blue-900 to-blue-800 absolute transform -translate-x-1/2 text-sm border-2 border-gray-200 p-4 w-48 h-auto shadow-md text-white hover:no-underline justify-start flex flex-col"
            )}
            role={"button"}
            style={{
                left: left || 0,
                top: top || 0,
            }}
            onClick={onClick}
        >
            <div className={"LocationTooltipContent"}>{props.children}</div>
            <div className={"TooltipArrow .external-css"}>&nbsp;</div>
        </button>
    );
};

interface LocationToolTipContentProps {
    hall: Hall;
}

const LocationToolTipContent = (props: LocationToolTipContentProps) => {
    const {hall} = props;
    return (
        <div
            className={"LocationToolTipContent flex flex-col justify-center items-center w-full text-lg divide-y space-y-6 p-3 divide-y-white "}
            role={"button"}
        >
            <div className={"h-10 w-full flex-shrink-0 flex flex-col justify-center items-center leading-5 uppercase"}>{hall.name}</div>
            <div className={"w-full flex flex-row justify-between items-center text-sm px-4 pt-4 text-center"}>{hall.short_address}</div>
        </div>
    );
};

interface MapLocationProps {
    hallIndex: number;
    hall: Hall;
    status: any;
    onClick: (hall) => void;
    tooltipActive: boolean | null;
    left: number;
    top: number;
}

const MapLocation = (props: MapLocationProps) => {
    const {hallIndex, hall, onClick, tooltipActive, left, top} = props;
    return (
        <div key={hallIndex} className={"MapPoint"}>
            <LocationTooltip active={tooltipActive} left={left} top={top} onClick={onClick}>
                <LocationToolTipContent hall={hall} />
            </LocationTooltip>
        </div>
    );
};
interface WorldMapLocationsProps {
    halls: Hall[];
    onClick: (hall) => void;
    active: number | boolean | null;
    left: number;
    top: number;
    width: number;
    tooltipActive: boolean | null;
}
const WorldMapLocations = (props: WorldMapLocationsProps) => {
    const {halls, onClick, active, left, top, tooltipActive} = props;

    return (
        <div className={"MapPoints fixed inset-0 z-20 pointer-events-none"}>
            {halls
                .filter((hall, hallIndex) => hallIndex === active)
                .map((hall, hallIndex) => {
                    console.log(active);
                    return (
                        <MapLocation
                            key={hallIndex}
                            hall={hall}
                            hallIndex={hallIndex}
                            left={left}
                            status={hall.status}
                            tooltipActive={tooltipActive}
                            top={top}
                            onClick={onClick}
                        />
                    );
                })}
        </div>
    );
};

export default WorldMapLocations;
